var _rect, _path, _path2, _path3, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEmailinline = function SvgEmailinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M40.049 39.711H15.95a4.5 4.5 0 0 1-4.5-4.5V20.79a4.5 4.5 0 0 1 4.5-4.5H40.05a4.5 4.5 0 0 1 4.5 4.5V35.21a4.5 4.5 0 0 1-4.5 4.5ZM15.95 17.414a3.375 3.375 0 0 0-3.375 3.375V35.21a3.375 3.375 0 0 0 3.375 3.375H40.05a3.375 3.375 0 0 0 3.375-3.375V20.79a3.375 3.375 0 0 0-3.375-3.375H15.95Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M28 31.139a4.5 4.5 0 0 1-2.711-.889l-13.14-9.95a.562.562 0 1 1 .664-.895l13.15 9.928a3.375 3.375 0 0 0 4.073 0l13.151-9.928a.563.563 0 1 1 .681.894L30.711 30.25a4.5 4.5 0 0 1-2.711.889Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    d: "M12.346 37.36a.563.563 0 0 1-.372-.979l10.345-9.23a.566.566 0 0 1 .748.849l-10.345 9.22a.563.563 0 0 1-.376.14Zm31.308 0a.563.563 0 0 1-.377-.14L32.934 28a.564.564 0 0 1 .114-.948.563.563 0 0 1 .634.11l10.345 9.22a.563.563 0 0 1-.144.93.562.562 0 0 1-.228.048Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    stroke: "#000",
    rx: 11.5
  })));
};
export default SvgEmailinline;